<template>
	<div class="menu-mask">
		<div class="logo-box">
			<img src="@/assets/imgs/hakko-logo.png" alt="logo" />
		</div>
		<div class="route-list">
			<div class="page-router-item" v-for="(item, index) in pageRouterList" :key="item.id" @click="handlePageRouterClick(item)">
				<div class="page-router-item-left">
					<span class="page-router-item-left-s">{{ $t(`header.${item.nameKey}` as string) }}</span>
					<span class="page-router-item-left-t">{{ item.routeTitle }}</span>
				</div>
				<div class="page-router-item-center">
					<!-- <img src="@/assets/imgs/icon-arrow-right.png" alt="arrow" /> -->
				</div>
				<div class="page-router-item-right">
					<span>0{{ index + 1 }}</span>
				</div>
			</div>
			<!-- <span class="page-router-item-ja">{{ $t(`header.${item.nameKey}` as string) }}</span> -->
		</div>
		<div class="sns-list">
			<div class="icon-box" @click="handleSnsClick('x')">
				<img src="@/assets/imgs/x.png" alt="x" />
			</div>
			<div class="icon-box" @click="handleSnsClick('discord')">
				<img src="@/assets/imgs/game.png" alt="game" />
			</div>
			<div class="icon-box" @click="handleSnsClick('youtube')">
				<img src="@/assets/imgs/youtube.png" alt="youtube" />
			</div>
		</div>
		<div class="download-btns">
			<div class="mobile" @click="handleDownloadApp">
				<img src="@/assets/imgs/icon-mobile-white.png" alt="download" />
				<div class="btn-item-text">
					<span>{{ $t("home.MobileDownload[0]") }}</span>
					<span>{{ $t("home.MobileDownload[1]") }}</span>
				</div>
			</div>
			<div class="pc" @click="handleDownloadPCClick">
				<img src="@/assets/imgs/icon-pc-white.png" alt="download" />
				<div class="btn-item-text">
					<span>{{ $t("home.PCDownload[0]") }}</span>
					<span>{{ $t("home.PCDownload[1]") }}</span>
				</div>
			</div>
		</div>
		<div class="close-btn" @click="closeMenu"></div>
	</div>
</template>
<script setup lang="ts">
import { handleDownloadPC, handleDownloadApp } from "@/utils/download";
const emit = defineEmits(["closeMenu", "jumpPage", "handleSnsClick"]);
const props = defineProps<{
	pageRouterList: PageRouterItem[];
}>();

const { locale } = useI18n();
const closeMenu = () => {
	emit("closeMenu");
};

const handlePageRouterClick = (item: PageRouterItem) => {
	emit("closeMenu");
	emit("jumpPage", item);
};

const handleSnsClick = (type: string) => {
	emit("closeMenu");
	emit("handleSnsClick", type);
};

const handleDownloadPCClick = () => {
	handleDownloadPC(locale.value);
};
</script>
<style scoped lang="scss">
.menu-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-image: url("@/assets/imgs/bg-mobile-menu.webp");
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	z-index: 1000;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-content: flex-start;

	.logo-box {
		height: 14px;
		top: 33px;
		left: 20px;
		margin: 33px 0 0 20px;

		img {
			width: 100%;
			height: 100%;
			display: flex;
		}
	}

	.route-list {
		width: 325px;
		height: fit-content;
		margin: 42px 0 0 30px;
		.page-router-item {
			width: 100%;
			height: 42px;
			display: flex;
			margin-bottom: 25px;
			.page-router-item-left {
				display: flex;
				flex-direction: column;
				.page-router-item-left-s {
					font-weight: 700;
					font-size: 14px;
					line-height: 1em;
					color: #ff6ba1;
					margin-bottom: auto;
				}
				.page-router-item-left-t {
					font-family: Source Han Sans CN;
					font-weight: 700;
					font-size: 20px;
					line-height: 20px;
					color: #b5b5b566;
				}
			}
			.page-router-item-center {
				flex: 1;
				margin: 0 7px 4px 5px;
				border-bottom: 1px dotted #49494933;
			}
			.page-router-item-right {
				width: fit-content;
				display: flex;
				align-items: flex-end;

				span {
					font-weight: 700;
					font-size: 20px;
					line-height: 20px;
					color: #fff;
					filter: drop-shadow(0px 0px 0.5px #0073ff);
				}
			}
		}
	}

	.sns-list {
		width: 100%;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 68px;
		margin: 7px 0 40px;
		.icon-box {
			width: 30px;
			height: 30px;
			display: flex;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.download-btns {
		width: 100%;
		height: 34px;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 20px;
		& > div {
			width: 124px;
			height: 34px;
			border-radius: 17px;
			background: linear-gradient(273.99deg, #7fb9ff 5.63%, #ffa0c0 50.52%);
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 25px;
				height: 25px;
			}
			.btn-item-text {
				width: fit-content;
				display: flex;
				flex-direction: column;
				align-items: left;
				justify-content: center;
				font-family: Source Han Sans CN;
				font-weight: 700;
				color: #fff;
				span {
					font-weight: 700;
					font-size: 12px;
					line-height: 14px;
				}
			}
		}
	}

	.close-btn {
		position: absolute;
		width: 30px;
		height: 30px;
		background-image: url("@/assets/imgs/icon-close-btn.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		top: 33px;
		right: 20px;
	}
}

.v-enter-active,
.v-leave-active {
	transition: all 0.5s ease;
	opacity: 1;
	transform: translateX(0) translateY(0) scale(1);
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateX(100%) translateY(-100%) scale(0.2);
}
</style>
